module.exports = __webpack_public_path__ + "img/man_suit_coffee.8df38bc6.svg";